import React from "react";
import { MDBDataTable } from "mdbreact";
import { DEFAULTORDER } from "../../../images/images";
import { numberWithCommas, orderPrice } from "./orderUtils";

// Renders the main item value on top and each option's value underneath it
function ItemCell({ main, options, getOptionValue }) {
  return (
    <span>
      <span> {main} </span>
      <br></br>
      <span>
        {" "}
        {options &&
          options.map((option, key) => {
            const value = getOptionValue(option);
            return value ? (
              <span key={key}>
                {value} <br></br>{" "}
              </span>
            ) : null;
          })}{" "}
      </span>
    </span>
  );
}

function createTableData(orderItems) {
  if (!Array.isArray(orderItems)) return undefined;

  return orderItems.map((item) => ({
    photo: <img className="order_img" src={DEFAULTORDER} alt="order_image" />,
    name: (
      <ItemCell
        main={item.name}
        options={item.options}
        getOptionValue={(option) => option.name}
      />
    ),
    quantity: (
      <ItemCell
        main={item.quantity}
        options={item.options}
        getOptionValue={(option) => option.quantity}
      />
    ),
    unit_price: (
      <ItemCell
        main={`₦${numberWithCommas(item.price)}`}
        options={item.options}
        getOptionValue={(option) =>
          option.price && `₦${numberWithCommas(option.price)}`
        }
      />
    ),
    order_price: (
      <ItemCell
        main={`₦${numberWithCommas(orderPrice(item.quantity, item.price))}`}
        options={item.options}
        getOptionValue={(option) =>
          option.price &&
          `₦${numberWithCommas(orderPrice(option.price, option.quantity))}`
        }
      />
    ),
  }));
}

export default function OrderItemsTable({ singleOrder }) {
  const unitText = singleOrder?.second_party_order
    ? "Unit Value "
    : "Unit Price";
  const labelText = singleOrder?.second_party_order
    ? "Order Value"
    : "Order Price";

  const data = {
    columns: [
      { label: "Image", field: "photo", sort: "asc", width: 150 },
      { label: "Order Name", field: "name", sort: "asc", width: 150 },
      { label: "Order Quantity", field: "quantity", sort: "asc", width: 150 },
      { label: unitText, field: "unit_price", sort: "asc", width: 150 },
      { label: labelText, field: "order_price", sort: "asc", width: 150 },
    ],
    rows: createTableData(singleOrder?.order_items),
  };

  return (
    <MDBDataTable
      responsive
      scrollY
      entriesOptions={[5, 10, 15]}
      striped
      borderless
      hover
      noBottomColumns
      displayEntries={false}
      searching={false}
      paging={false}
      data={data}
    />
  );
}
